/** Finger names and colours shared by the keyboard and the hand hint. No standard
 *  scheme exists, so this uses one colour per finger, mirrored across both hands. */

export const FINGER_COLORS = {
    lp: '#f472b6', // pinky — pink
    lr: '#fbbf24', // ring — amber
    lm: '#34d399', // middle — green
    li: '#60a5fa', // index — blue
    th: '#c084fc', // thumb — purple
    ri: '#60a5fa',
    rm: '#34d399',
    rr: '#fbbf24',
    rp: '#f472b6',
};

export const FINGER_NAMES = {
    bn: { lp: 'বাঁ কনিষ্ঠা', lr: 'বাঁ অনামিকা', lm: 'বাঁ মধ্যমা', li: 'বাঁ তর্জনী', th: 'বুড়ো আঙুল', ri: 'ডান তর্জনী', rm: 'ডান মধ্যমা', rr: 'ডান অনামিকা', rp: 'ডান কনিষ্ঠা' },
    en: { lp: 'Left pinky', lr: 'Left ring', lm: 'Left middle', li: 'Left index', th: 'Thumb', ri: 'Right index', rm: 'Right middle', rr: 'Right ring', rp: 'Right pinky' },
};

export const fingerColor = (finger) => FINGER_COLORS[finger] || '#cbd5e1';
